module.exports = __webpack_public_path__ + "images/storefront-blue-078b735d.svg";